import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "toast-content-text"
};
import SvgIcon from "./SvgIcon.vue";
import { computed } from "vue";
export default {
  __name: 'ToastContent',
  props: {
    message: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "fail"
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var SvgIconName = computed(function () {
      return {
        fail: "toast_fail"
      }[props.type];
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass("toast-content toast-content-".concat(__props.type))
      }, [SvgIconName.value ? (_openBlock(), _createBlock(SvgIcon, {
        key: 0,
        class: "toast-content-icon",
        name: SvgIconName.value,
        size: "24"
      }, null, 8, ["name"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, _toDisplayString(__props.message), 1)], 2);
    };
  }
};